'use client';

import * as React from 'react';
import { Input, type InputProps } from './input';

export interface PhoneInputProps extends Omit<InputProps, 'type'> {
  value?: string;
}

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onChange, ...props }, ref) => {
    const formatPhoneNumber = (value: string) => {
      const cleaned = value?.replace(/\D/g, '') || '';
      const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

      if (!match) return '';

      const parts = [match[1], match[2], match[3]].filter(Boolean);
      return parts.join('-');
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const input = e.target.value;
      const cleaned = input.replace(/\D/g, '');

      if (cleaned.length <= 10 && onChange) {
        const syntheticEvent = {
          ...e,
          target: {
            ...e.target,
            value: cleaned,
          },
        };
        onChange(syntheticEvent as any);
      }
    };

    return (
      <Input
        {...props}
        ref={ref}
        type="tel"
        value={formatPhoneNumber(value || '')}
        onChange={handleChange}
        placeholder="555-555-5555"
        maxLength={12}
      />
    );
  }
);

PhoneInput.displayName = 'PhoneInput';

export { PhoneInput };
